import React from "react";
import { Plus, BadgePercent } from "lucide-react";
import { useCart } from "../context/CartContext";
import { formatEUR } from "../lib/api";

const ProductCard = ({ product }) => {
  const { add } = useCart();
  const showStrike = product.has_custom_price && product.effective_price !== product.base_price;

  return (
    <article
      className="group bg-white border border-sky-100 rounded-2xl overflow-hidden hover:shadow-[0_20px_50px_-20px_rgba(0,163,255,0.35)] hover:-translate-y-1 transition-all duration-300"
      data-testid={`product-card-${product.slug}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-sky-50">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {product.has_custom_price && (
          <span className="absolute top-3 left-3 bg-[#00A3FF] text-white text-[10px] tracking-wider uppercase font-bold px-2.5 py-1 rounded-full flex items-center gap-1" data-testid={`custom-price-badge-${product.slug}`}>
            <BadgePercent className="w-3 h-3" /> Prezzo Cliente
          </span>
        )}
      </div>

      <div className="p-6">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-sky-600 mb-2">
          {product.unit}
        </p>
        <h3 className="font-heading text-xl font-medium text-[#032B44] mb-2">{product.name}</h3>
        <p className="text-sm text-slate-600 leading-relaxed line-clamp-2 mb-5">
          {product.description}
        </p>

        <div className="flex items-end justify-between">
          <div>
            {showStrike && (
              <div className="text-xs text-slate-400 line-through" data-testid={`product-base-price-${product.slug}`}>
                {formatEUR(product.base_price)}
              </div>
            )}
            <div className="font-heading text-2xl text-[#032B44] font-semibold leading-none" data-testid={`product-price-${product.slug}`}>
              {formatEUR(product.effective_price)}
            </div>
          </div>
          <button
            onClick={() => add(product)}
            className="h-11 px-4 rounded-lg bg-[#032B44] hover:bg-[#00A3FF] text-white text-sm font-medium flex items-center gap-1.5 transition-colors"
            data-testid={`add-to-cart-${product.slug}`}
          >
            <Plus className="w-4 h-4" /> Aggiungi
          </button>
        </div>
      </div>
    </article>
  );
};

export default ProductCard;
